import type { SvgIconProps } from '@mildang/mui';

const logoSrc = new URL('./assets/logo_b2c.svg', import.meta.url).href;

const MildangStudentLogoV2 = (props: SvgIconProps) => (
  <svg
    width="112"
    height="30"
    viewBox="0 0 112 30"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="밀당PT Study"
    {...props}
  >
    <image href={logoSrc} y="0.855548" width="111.072" height="28.2889" />
  </svg>
);

export default MildangStudentLogoV2;
